import { useEffect, useState } from "react";
import axios from "axios";
import ReusableDataTable from "../../hooks/ReusableDataTable";

function RejectionSectionTabs({ selectedBuyer, selectedOrder, selectedSubOrder }) {
    const [activeTab, setActiveTab] = useState("production");
    const [rejectionList, setRejectionList] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const buyerParam = selectedBuyer !== "All Buyers" ? `&buyer_id=${selectedBuyer}` : "";
                const orderParam = selectedOrder !== "All Orders" ? `&order_id=${selectedOrder}` : "";
                const subOrderParam = selectedSubOrder !== "All Sub Orders" ? `&sub_order_id=${selectedSubOrder}` : "";

                const endpoint =
                    activeTab === "production" ? "producation/rejection/production" : "producation/rejection/pressing";

                const res = await axios.get(`${endpoint}?${buyerParam}${orderParam}${subOrderParam}`);
                setRejectionList(res.data.data || []);
            } catch (err) {
                console.error(`Error fetching ${activeTab} rejection data`, err);
            }
        };

        fetchData();
    }, [activeTab, selectedBuyer, selectedOrder, selectedSubOrder]);

    const columns = [
        { name: "Date", selector: (row) => row.date || "-", sortable: true },
        { name: "Staff", selector: (row) => row.staff_name || "-", sortable: true },
        { name: "Line", selector: (row) => row.line || "-", sortable: true },
        { name: "Order No", selector: (row) => row.cut_order_no || "-", sortable: true },
        { name: "Colour", selector: (row) => row.colour_name || "-", sortable: true },
        {
            name: "Size-Qty",
            selector: (row) =>
                row.size_variant_quantity
                    ? Object.entries(row.size_variant_quantity)
                        .map(([size, qty]) => `${size}: ${qty}`)
                        .join(", ")
                    : "-",
        },
        { name: "Total Pieces", selector: (row) => row.total_piece || 0, sortable: true },
    ];

    return (
        <div className="p-4 bg-white rounded shadow-md">
            <div className="flex space-x-4 mb-4">
                <button
                    onClick={() => setActiveTab("production")}
                    className={`px-4 py-2 rounded ${activeTab === "production" ? "bg-blue-600 text-white" : "bg-gray-200"
                        }`}
                >
                    Production
                </button>
                <button
                    onClick={() => setActiveTab("pressing")}
                    className={`px-4 py-2 rounded ${activeTab === "pressing" ? "bg-blue-600 text-white" : "bg-gray-200"
                        }`}
                >
                    Pressing
                </button>
            </div>

            {rejectionList.length === 0 ? (
                <p className="text-gray-500">No rejection data available for {activeTab}.</p>
            ) : (
                <ReusableDataTable
                    columns={columns}
                    data={rejectionList}
                    pagination
                    highlightOnHover
                    dense
                />
            )}
        </div>
    );
}

export default RejectionSectionTabs;
